var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.57664 44.5878C9.27604 44.5873 8.97884 44.5242 8.70393 44.4026C8.42902 44.281 8.18242 44.1035 7.97981 43.8815C7.77354 43.6613 7.61614 43.4 7.51794 43.1147C7.41974 42.8294 7.38294 42.5266 7.40998 42.2261L7.94081 36.3891L32.4631 11.8755L40.1266 19.5368L15.6108 44.0483L9.77381 44.5791C9.70827 44.5852 9.64247 44.5881 9.57664 44.5878ZM41.6563 18.005L33.995 10.3436L38.5905 5.74813C38.7917 5.54668 39.0307 5.38687 39.2937 5.27783C39.5567 5.16879 39.8387 5.11267 40.1234 5.11267C40.4081 5.11267 40.6901 5.16879 40.9531 5.27783C41.2161 5.38687 41.4551 5.54668 41.6563 5.74813L46.2518 10.3436C46.4533 10.5449 46.6131 10.7838 46.7221 11.0468C46.8311 11.3099 46.8873 11.5918 46.8873 11.8765C46.8873 12.1613 46.8311 12.4432 46.7221 12.7062C46.6131 12.9693 46.4533 13.2082 46.2518 13.4095L41.6585 18.0028L41.6563 18.005Z",
    fill: "url(#paint0_linear_24_253)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_24_253",
    x1: 46.7116,
    y1: 5.28804,
    x2: 7.05063,
    y2: 41.8643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C1C46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3EBB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon_edit.67d53df8c4205a7591b192543fafaabb.svg";
export { ForwardRef as ReactComponent };